import { reducer as allAlternativeCampaigns } from './allAlternativeCampaigns'
import { reducer as allowedNamesAlternativeCampaigns } from './allowedNamesAlternativeCampaigns'
import { reducer as closeAlternativeCampaign } from './closeAlternativeCampaign'
import { reducer as createAlternativeCampaign } from './createAlternativeCampaign'
import { reducer as getAlternativeCampaign } from './getAlternativeCampaign'
import { reducer as selectedExtraCampaign } from './selectedExtraCampaign'
import { reducer as sendEmailsAlternativeCampaign } from './sendEmailsAlternativeCampaign'
import { reducer as codesResetAlternativeCampaign } from './codesResetAlternativeCampaign'
import { reducer as codesDeleteAlternativeCampaign } from './codesDeleteAlternativeCampaign'
import { reducer as resetManyAlternativeCampaign } from './resetManyAlternativeCampaign'
import { reducer as deleteManyAlternativeCampaign } from './deleteManyAlternativeCampaign'
import { reducer as getUnassignedAlternativeCampaign } from './getUnassignedAlternativeCampaign'
import { reducer as getAlternativeIndividualEmails } from './getAlternativeIndividualEmails'
import { reducer as getAlternativeEmailsHistory } from './getAlternativeEmailsHistory'
import { reducer as getExtraCurrentEmailTemplate } from './getExtraCurrentEmailTemplate'
import { reducer as updateExtraCurrentEmailTemplate } from './updateExtraCurrentEmailTemplate'
import { reducer as alternativeCampaignAddEmail } from './alternativeCampaignAddEmail'

export default {
  allAlternativeCampaigns,
  allowedNamesAlternativeCampaigns,
  closeAlternativeCampaign,
  createAlternativeCampaign,
  getAlternativeCampaign,
  selectedExtraCampaign,
  sendEmailsAlternativeCampaign,
  codesResetAlternativeCampaign,
  codesDeleteAlternativeCampaign,
  resetManyAlternativeCampaign,
  deleteManyAlternativeCampaign,
  getUnassignedAlternativeCampaign,
  getAlternativeIndividualEmails,
  getAlternativeEmailsHistory,
  getExtraCurrentEmailTemplate,
  updateExtraCurrentEmailTemplate,
  alternativeCampaignAddEmail
}



// WEBPACK FOOTER //
// ./src/store/extra-campaign/index.js